import { __values, __decorate, __metadata, __extends, __param } from 'tslib';
import { Directive, ElementRef, Input, Pipe, NgModule, HostBinding, EventEmitter, Output, Optional, ViewChild, TemplateRef, ContentChildren, QueryList, HostListener, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgControl } from '@angular/forms';
import { coerceBooleanProperty, KEYS } from '@uikit/components/helpers';
import { Subject } from 'rxjs';

var UkButtonGroupDirective = /** @class */ (function () {
    function UkButtonGroupDirective(container) {
        this.container = container;
    }
    UkButtonGroupDirective.prototype.ngAfterContentInit = function () {
        var e_1, _a;
        var buttons = this.container.nativeElement.querySelectorAll('.uk-btn');
        var sizes = [];
        try {
            for (var buttons_1 = __values(buttons), buttons_1_1 = buttons_1.next(); !buttons_1_1.done; buttons_1_1 = buttons_1.next()) {
                var button = buttons_1_1.value;
                sizes.push(button.offsetWidth);
                button.style.width = Math.max.apply(Math, sizes) + "px";
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (buttons_1_1 && !buttons_1_1.done && (_a = buttons_1.return)) _a.call(buttons_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    UkButtonGroupDirective = __decorate([
        Directive({
            selector: '[ukButtonGroup]',
            host: {
                class: 'uk-btn-container'
            }
        }),
        __metadata("design:paramtypes", [ElementRef])
    ], UkButtonGroupDirective);
    return UkButtonGroupDirective;
}());

var UkAutofocusDirective = /** @class */ (function () {
    function UkAutofocusDirective(el) {
        this.el = el;
    }
    Object.defineProperty(UkAutofocusDirective.prototype, "ukAutofocus", {
        set: function (value) {
            if (value === true) {
                this.el.nativeElement.focus();
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UkAutofocusDirective.prototype, "ukAutofocus", null);
    UkAutofocusDirective = __decorate([
        Directive({
            selector: '[ukAutofocus]'
        }),
        __metadata("design:paramtypes", [ElementRef])
    ], UkAutofocusDirective);
    return UkAutofocusDirective;
}());

var UkEmailPipe = /** @class */ (function () {
    function UkEmailPipe() {
    }
    UkEmailPipe.prototype.transform = function (value) {
        var newValue = value.substr(0, 2) + '***';
        var arrobaIdx = value.indexOf('@');
        if (arrobaIdx > 5)
            newValue += value.substring(arrobaIdx - 2, arrobaIdx);
        return newValue + value.substring(arrobaIdx);
    };
    UkEmailPipe = __decorate([
        Pipe({ name: 'ukEmailHide' })
    ], UkEmailPipe);
    return UkEmailPipe;
}());

var UkPhonePipe = /** @class */ (function () {
    function UkPhonePipe() {
    }
    UkPhonePipe.prototype.transform = function (value, hide) {
        if (hide === void 0) { hide = false; }
        var str = value.toString();
        if (hide)
            return this.maskTransform(str);
        return "(" + str.slice(0, 3) + ") " + str.slice(3, 6) + " " + str.slice(6);
    };
    UkPhonePipe.prototype.maskTransform = function (value) {
        return "(***) ***-" + value.slice(6);
    };
    UkPhonePipe = __decorate([
        Pipe({ name: 'ukPhoneSecure' })
    ], UkPhonePipe);
    return UkPhonePipe;
}());

var UK_SSN_SEPERATOR = '-';
var UK_SSN_MASK_SECTIONS = [3, 2, 4];
var UkSSNPipe = /** @class */ (function () {
    function UkSSNPipe() {
        this.separator = UK_SSN_SEPERATOR;
        this.separatorReg = new RegExp(this.separator, 'g');
    }
    UkSSNPipe.prototype.transform = function (value) {
        var cleanValue = value.replace(this.separatorReg, '').trim();
        var format = [], idx = 0;
        UK_SSN_MASK_SECTIONS.forEach(function (sec) {
            var secMax = idx + sec;
            if (cleanValue.length < secMax) {
                secMax = cleanValue.length;
            }
            if (idx < value.length) {
                format.push(value.substring(idx, secMax));
            }
            idx = secMax;
        });
        return format.join(this.separator);
    };
    UkSSNPipe = __decorate([
        Pipe({ name: 'ukSSNFormat' })
    ], UkSSNPipe);
    return UkSSNPipe;
}());

var UIKitCommonModule = /** @class */ (function () {
    function UIKitCommonModule() {
    }
    UIKitCommonModule = __decorate([
        NgModule({
            imports: [CommonModule],
            declarations: [
                UkButtonGroupDirective,
                UkAutofocusDirective,
                UkPhonePipe,
                UkSSNPipe,
                UkEmailPipe
            ],
            exports: [
                UkButtonGroupDirective,
                UkAutofocusDirective,
                UkPhonePipe,
                UkSSNPipe,
                UkEmailPipe
            ]
        })
    ], UIKitCommonModule);
    return UIKitCommonModule;
}());

var uniqueId = {};
function getUniqueID(controlType) {
    var _uniqueID = uniqueId[controlType];
    uniqueId[controlType] = _uniqueID === undefined ? 0 : ++_uniqueID;
    return uniqueId[controlType];
}
var UkGenericComponent = /** @class */ (function () {
    function UkGenericComponent(controlType) {
        this.controlType = controlType;
        // Needed otherwise the id is not assigned
        this.id = this.id;
    }
    Object.defineProperty(UkGenericComponent.prototype, "id", {
        get: function () { return this._id; },
        set: function (value) {
            this._id = value || "uk-" + this.controlType + "-" + getUniqueID(this.controlType);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        HostBinding('attr.id'), Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], UkGenericComponent.prototype, "id", null);
    return UkGenericComponent;
}());

function onUKFormControlOnInit(component) {
    if (component.ngControl) {
        var control = component.ngControl.control;
        if (control.validator) {
            var validator = control.validator({});
            if (validator) {
                component.required = validator.required;
            }
        }
        component.invalid = component.ngControl.invalid;
        component.ngControl.statusChanges.subscribe(function () {
            component.invalid = component.ngControl.invalid;
            component.checkErrors(true);
        });
    }
}

var UkFieldRequiredError = {
    name: 'required',
    message: function (label) {
        return label + " field is required.";
    }
};
var UkFieldInvalidEmailError = {
    name: 'ukEmail',
    message: function (label) {
        return label + " should be at least 6 chars, maximum 68 and must be email format";
    }
};
var UkFieldInvalidUserNameError = {
    name: 'ukUserName',
    message: function (label) {
        return label + " should be at least 6 chars, maximum 30 and can contain \" _\",\"+\",\"-\", \".\"";
    }
};
var UkFieldMaxLengthError = {
    name: 'ukMaxLength',
    message: function (label, error) {
        return "Please enter no more than " + error.requiredLength + " characters.";
    }
};

function mixinErrorState(base) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            // ===> Manage Status <===
            _this.statusChange = new Subject();
            _this._invalid = false;
            // ===> Handle Error <===
            _this._pendingChanges = false;
            return _this;
        }
        Object.defineProperty(class_1.prototype, "invalid", {
            get: function () { return this._invalid; },
            set: function (value) {
                if (this._invalid !== value) {
                    this._invalid = value;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(class_1.prototype, "valid", {
            get: function () { return !this._invalid; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(class_1.prototype, "errors", {
            get: function () { return this._errors ? this._errors : {}; },
            enumerable: true,
            configurable: true
        });
        class_1.prototype.setError = function (name, error) {
            // Set control status to invalid
            this.invalid = true;
            if (!this._errors)
                this._errors = {};
            if (!this._errors[name]) {
                this._errors[name] = error;
                this._pendingChanges = true;
            }
        };
        class_1.prototype.removeError = function (name) {
            if (this._errors && this._errors[name]) {
                delete this._errors[name];
                this._pendingChanges = true;
            }
        };
        class_1.prototype.checkErrors = function (forceUpdate) {
            if (forceUpdate === void 0) { forceUpdate = false; }
            if (this.ngControl) {
                this.ngControl.hasError('required') ?
                    this.setError(UkFieldRequiredError.name, UkFieldRequiredError) :
                    this.removeError(UkFieldRequiredError.name);
                this.ngControl.hasError('ukUserName') ?
                    this.setError(UkFieldInvalidUserNameError.name, UkFieldInvalidUserNameError) :
                    this.removeError(UkFieldInvalidUserNameError.name);
                this.ngControl.hasError('ukEmail') ?
                    this.setError(UkFieldInvalidEmailError.name, UkFieldInvalidEmailError) :
                    this.removeError(UkFieldInvalidEmailError.name);
            }
            // Identify if there pending changes to avoid extra work on UI rendering
            if (this._pendingChanges || forceUpdate) {
                this.statusChange.next();
                this._pendingChanges = false;
            }
        };
        return class_1;
    }(base));
}

function mixinTouchable(base) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._touched = false;
            return _this;
        }
        Object.defineProperty(class_1.prototype, "untouched", {
            get: function () { return !this._touched; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(class_1.prototype, "touched", {
            get: function () {
                if (this.ngControl) {
                    if (this.ngControl.touched !== this._touched) {
                        this.setTouch(this.ngControl.touched);
                    }
                }
                return this.ngControl ? this.ngControl.touched : this._touched;
            },
            enumerable: true,
            configurable: true
        });
        class_1.prototype.setTouch = function (value) {
            this._touched = value;
            if (this.touched) {
                this.checkErrors(true);
            }
        };
        class_1.prototype.touchControl = function () {
            if (!this._touched) {
                this.setTouch(true);
            }
            if (this.onControlTouched)
                this.onControlTouched();
        };
        return class_1;
    }(base));
}

var NO_FN = function () { };
// ===> Manage Status <===
var _UkBaseFormControl = /** @class */ (function (_super) {
    __extends(_UkBaseFormControl, _super);
    function _UkBaseFormControl(ngControl, componentName) {
        var _this = _super.call(this, componentName) || this;
        _this.ngControl = ngControl;
        _this.componentName = componentName;
        return _this;
    }
    return _UkBaseFormControl;
}(UkGenericComponent));
var _UkBaseFormControlMixin = mixinTouchable(mixinErrorState(_UkBaseFormControl));
var UkBaseFormControl = /** @class */ (function (_super) {
    __extends(UkBaseFormControl, _super);
    function UkBaseFormControl(ngControl, componentName) {
        var _this = _super.call(this, ngControl, componentName) || this;
        _this.ngControl = ngControl;
        // ===> Manage Required <===
        _this._required = false;
        // ===> Manage Disable State <===
        _this._disabled = false;
        _this.disabledChange = new EventEmitter();
        // ===> Manage Focus <===
        _this._focused = false;
        _this.focusedChange = new EventEmitter();
        _this.valueChange = new EventEmitter();
        // To Manage NgModel
        if (_this.ngControl) {
            _this.ngControl.valueAccessor = _this;
        }
        else {
            _this.onModelChange = NO_FN;
            _this.onControlTouched = NO_FN;
        }
        return _this;
    }
    UkBaseFormControl.prototype.onClick = function (event) {
        // throw new Error("Method not implemented.");
    };
    Object.defineProperty(UkBaseFormControl.prototype, "invalidClass", {
        // ===> Manages UI <===
        get: function () { return this.invalid && this.touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkBaseFormControl.prototype, "required", {
        get: function () { return this._required; },
        set: function (value) {
            if (value !== this._required) {
                this._required = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkBaseFormControl.prototype, "disabled", {
        get: function () { return this._disabled; },
        set: function (value) {
            if (value !== this._disabled) {
                this._disabled = coerceBooleanProperty(value);
                this.disabledChange.emit(this.disabled);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkBaseFormControl.prototype, "focused", {
        get: function () { return this._focused; },
        set: function (value) {
            if (value !== this._focused) {
                if (this._focused) {
                    this.touchControl();
                }
                this._focused = coerceBooleanProperty(value);
                this.focusedChange.emit(this.focused);
            }
        },
        enumerable: true,
        configurable: true
    });
    // ===> Angular LifeCycle Hooks <===
    UkBaseFormControl.prototype.ngOnInit = function () { onUKFormControlOnInit(this); };
    Object.defineProperty(UkBaseFormControl.prototype, "value", {
        get: function () { return this._value; },
        set: function (value) {
            if (value !== this.value) {
                this.setValue(value);
                this.setNgValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    UkBaseFormControl.prototype.setValue = function (value) {
        this._value = value;
        this.checkErrors(true);
        this.valueChange.emit(this.value);
    };
    UkBaseFormControl.prototype.setNgValue = function (value) { if (this.onModelChange) {
        this.onModelChange(value);
    } };
    UkBaseFormControl.prototype.writeValue = function (value) { this.setValue(value); };
    UkBaseFormControl.prototype.registerOnChange = function (fn) { this.onModelChange = fn; };
    UkBaseFormControl.prototype.registerOnTouched = function (fn) { this.onControlTouched = fn; };
    UkBaseFormControl.prototype.setDisabledState = function (isDisabled) { this.disabled = isDisabled; };
    __decorate([
        HostBinding('class.uk-invalid'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UkBaseFormControl.prototype, "invalidClass", null);
    __decorate([
        Input() // @HostBinding('attr.required') => Find a way to set attribute
        ,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UkBaseFormControl.prototype, "required", null);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UkBaseFormControl.prototype, "disabledChange", void 0);
    __decorate([
        Input() // @HostBinding('attr.disabled') => Find a way to set attribute
        ,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UkBaseFormControl.prototype, "disabled", null);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UkBaseFormControl.prototype, "focusedChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UkBaseFormControl.prototype, "focused", null);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UkBaseFormControl.prototype, "valueChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], UkBaseFormControl.prototype, "value", null);
    UkBaseFormControl = __decorate([
        __param(0, Optional()),
        __metadata("design:paramtypes", [NgControl, String])
    ], UkBaseFormControl);
    return UkBaseFormControl;
}(_UkBaseFormControlMixin));

var UkChildItemComponent = /** @class */ (function (_super) {
    __extends(UkChildItemComponent, _super);
    function UkChildItemComponent(componentName) {
        var _this = _super.call(this, componentName) || this;
        // ===> Manage Disable State <===
        _this._disabled = false;
        _this.disabledChange = new EventEmitter();
        // ===> Manage Active State <===
        _this._active = false;
        _this.activeChange = new EventEmitter();
        // ===> Manage Selected State <===
        _this._selected = false;
        _this.selectedChange = new EventEmitter();
        _this.index = -1;
        return _this;
    }
    Object.defineProperty(UkChildItemComponent.prototype, "disabled", {
        get: function () { return this._disabled; },
        set: function (value) {
            if (value !== this._disabled) {
                this._disabled = coerceBooleanProperty(value);
                this.disabledChange.emit(this.disabled);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkChildItemComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            if (value !== this.active) {
                this._active = coerceBooleanProperty(value);
                this.activeChange.emit(this.active);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkChildItemComponent.prototype, "selected", {
        get: function () { return this._selected; },
        set: function (value) {
            if (value !== this._selected) {
                this._selected = coerceBooleanProperty(value);
                this.selectedChange.emit(this.selected);
            }
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Input('label'),
        __metadata("design:type", String)
    ], UkChildItemComponent.prototype, "textLabel", void 0);
    __decorate([
        ViewChild(TemplateRef, { static: true }),
        __metadata("design:type", TemplateRef)
    ], UkChildItemComponent.prototype, "content", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UkChildItemComponent.prototype, "disabledChange", void 0);
    __decorate([
        Input(), HostBinding('attr.disabled'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UkChildItemComponent.prototype, "disabled", null);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UkChildItemComponent.prototype, "activeChange", void 0);
    __decorate([
        Input(), HostBinding('class.uk-active'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UkChildItemComponent.prototype, "active", null);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UkChildItemComponent.prototype, "selectedChange", void 0);
    __decorate([
        Input(), HostBinding('class.uk-selected'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UkChildItemComponent.prototype, "selected", null);
    return UkChildItemComponent;
}(UkGenericComponent));

var UkSelectionChange = /** @class */ (function () {
    function UkSelectionChange(source, isUserInput) {
        if (isUserInput === void 0) { isUserInput = false; }
        this.source = source;
        this.isUserInput = isUserInput;
    }
    return UkSelectionChange;
}());
// tslint:disable-next-line:max-classes-per-file
var UkGroupComponent = /** @class */ (function (_super) {
    __extends(UkGroupComponent, _super);
    function UkGroupComponent(componentName, cdr) {
        var _this = _super.call(this, componentName) || this;
        _this.cdr = cdr;
        _this._selectedIndex = 0;
        _this.fowardKeys = [KEYS.ArrowRight];
        _this.backKeys = [KEYS.ArrowLeft];
        _this.onSelectionChange = new EventEmitter();
        return _this;
    }
    Object.defineProperty(UkGroupComponent.prototype, "selectedIndex", {
        get: function () { return this._selectedIndex; },
        set: function (value) {
            var _this = this;
            if (value >= 0 && value < this._items.length) {
                if (this._selectedIndex >= 0) {
                    var currentItem = this._items.find(function (item) { return item.index === _this._selectedIndex; });
                    currentItem.selected = false;
                }
                this._selectedIndex = value;
                var newItem = this._items.find(function (item) { return item.index === _this._selectedIndex; });
                newItem.selected = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    UkGroupComponent.prototype.keyNavigation = function (event) {
        event.key === KEYS.Enter ? this.selectCorrect() : this.navigate(event);
        event.stopPropagation();
    };
    UkGroupComponent.prototype.selectCorrect = function () { this.selectIndex(this.selectedIndex, true); };
    UkGroupComponent.prototype.moveIndex = function (steps) { this.selectedIndex = this.selectedIndex + steps; };
    UkGroupComponent.prototype.move = function (positions) {
        this.moveIndex(positions);
        this.selectCorrect();
    };
    UkGroupComponent.prototype.next = function () { this.move(1); };
    UkGroupComponent.prototype.previous = function () { this.move(-1); };
    UkGroupComponent.prototype.select = function (item, isUserInput, toogle) {
        if (isUserInput === void 0) { isUserInput = false; }
        if (toogle === void 0) { toogle = false; }
        if (!item.disabled) {
            var currentItem = this._items.find(function (_item) { return _item.active; });
            if (currentItem !== item) {
                if (currentItem) {
                    currentItem.active = false;
                    currentItem.selected = false;
                }
                item.active = true;
                this._selectedIndex = item.index;
                this.onSelectionChange.emit(new UkSelectionChange(item, isUserInput));
            }
            else if (toogle) {
                item.active = !item.active;
            }
            this.cdr.detectChanges();
        }
    };
    UkGroupComponent.prototype.navigate = function (event, select) {
        if (select === void 0) { select = false; }
        var key = event.key;
        var isFoward = this.fowardKeys.indexOf(key) >= 0;
        var isBack = this.backKeys.indexOf(key) >= 0;
        if (isFoward || isBack) {
            this.moveIndex(isBack ? -1 : 1);
            if (select) {
                this.selectCorrect();
            }
            event.preventDefault();
        }
    };
    UkGroupComponent.prototype.selectIndex = function (index, isUserInput) {
        var currentItem = this._items.find(function (item) { return item.index === index; });
        if (currentItem) {
            this.select(currentItem, isUserInput);
        }
    };
    UkGroupComponent.prototype.proccessItems = function (list) {
        var _this = this;
        list.forEach(function (item, idx) {
            item.index = idx;
            item.selectedChange.subscribe(function (_selected) {
                if (_selected) {
                    _this.select(item, true);
                }
            });
        });
        // Selects current index
        // this.selectIndex(this.selectedIndex, false);
    };
    // Angular LifeCycle Hooks
    UkGroupComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._items.changes.subscribe(function (list) {
            _this.proccessItems(list);
            _this.cdr.markForCheck();
        });
        this.proccessItems(this._items);
    };
    __decorate([
        Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Object])
    ], UkGroupComponent.prototype, "selectedIndex", null);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UkGroupComponent.prototype, "onSelectionChange", void 0);
    __decorate([
        ContentChildren(UkChildItemComponent),
        __metadata("design:type", QueryList)
    ], UkGroupComponent.prototype, "_items", void 0);
    __decorate([
        HostListener('keydown', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [KeyboardEvent]),
        __metadata("design:returntype", void 0)
    ], UkGroupComponent.prototype, "keyNavigation", null);
    return UkGroupComponent;
}(UkGenericComponent));

var NO_FN$1 = function () { };
var UkGenericFormGroupComponent = /** @class */ (function (_super) {
    __extends(UkGenericFormGroupComponent, _super);
    function UkGenericFormGroupComponent(ngControl, componentName, cdr) {
        var _this = _super.call(this, componentName, cdr) || this;
        _this.ngControl = ngControl;
        _this.componentName = componentName;
        return _this;
    }
    return UkGenericFormGroupComponent;
}(UkGroupComponent));
var _UkGenericFormGroupMixin = mixinTouchable(mixinErrorState(UkGenericFormGroupComponent));
var UkFormGroupComponent = /** @class */ (function (_super) {
    __extends(UkFormGroupComponent, _super);
    function UkFormGroupComponent(ngControl, componentName, cdr) {
        var _this = _super.call(this, ngControl, componentName, cdr) || this;
        /** ===> Manage Required <=== */
        _this._required = false;
        /** ===> Manage Disable State <=== */
        _this._disabled = false;
        _this.disabledChange = new EventEmitter();
        /** ===> Manage Focus <=== */
        _this._focused = false;
        _this.focusedChange = new EventEmitter();
        _this.valueChange = new EventEmitter();
        // To Manage NgModel
        if (_this.ngControl) {
            _this.ngControl.valueAccessor = _this;
        }
        else {
            _this.onModelChange = NO_FN$1;
            _this.onControlTouched = NO_FN$1;
        }
        return _this;
    }
    UkFormGroupComponent.prototype.onClick = function (event) { };
    Object.defineProperty(UkFormGroupComponent.prototype, "invalidClass", {
        /** ===> Manages UI <=== */
        get: function () { return this.invalid && this.touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkFormGroupComponent.prototype, "required", {
        get: function () { return this._required; },
        set: function (value) {
            if (value !== this._required) {
                this._required = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkFormGroupComponent.prototype, "disabled", {
        get: function () { return this._disabled; },
        set: function (value) {
            if (value !== this._disabled) {
                this._disabled = coerceBooleanProperty(value);
                this.disabledChange.emit(this.disabled);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkFormGroupComponent.prototype, "focused", {
        get: function () { return this._focused; },
        set: function (value) {
            if (value !== this._focused) {
                if (this._focused) {
                    this.touchControl();
                }
                this._focused = coerceBooleanProperty(value);
                this.focusedChange.emit(this.focused);
            }
        },
        enumerable: true,
        configurable: true
    });
    /** ===> Angular LifeCycle Hooks <=== */
    UkFormGroupComponent.prototype.ngOnInit = function () { onUKFormControlOnInit(this); };
    // Fix for Angular LifeCycle not trigger with mixins
    // #region Fix
    UkFormGroupComponent.prototype.ngAfterContentInit = function () {
        _super.prototype.ngAfterContentInit.call(this);
    };
    Object.defineProperty(UkFormGroupComponent.prototype, "value", {
        get: function () { return this._value; },
        set: function (value) {
            if (value !== this.value) {
                this.setValue(value);
                this.setNgValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    UkFormGroupComponent.prototype.setValue = function (value) {
        this._value = value;
        this.valueChange.emit(this.value);
    };
    UkFormGroupComponent.prototype.setNgValue = function (value) { if (this.onModelChange) {
        this.onModelChange(value);
    } };
    UkFormGroupComponent.prototype.writeValue = function (value) { this.setValue(value); };
    UkFormGroupComponent.prototype.registerOnChange = function (fn) { this.onModelChange = fn; };
    UkFormGroupComponent.prototype.registerOnTouched = function (fn) { this.onControlTouched = fn; };
    UkFormGroupComponent.prototype.setDisabledState = function (isDisabled) { this.disabled = isDisabled; };
    __decorate([
        HostBinding('class.uk-invalid'),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], UkFormGroupComponent.prototype, "invalidClass", null);
    __decorate([
        Input() // @HostBinding('attr.required') => Find a way to set attribute
        ,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UkFormGroupComponent.prototype, "required", null);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UkFormGroupComponent.prototype, "disabledChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UkFormGroupComponent.prototype, "disabled", null);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UkFormGroupComponent.prototype, "focusedChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [Boolean])
    ], UkFormGroupComponent.prototype, "focused", null);
    __decorate([
        ContentChildren(UkChildItemComponent),
        __metadata("design:type", QueryList)
    ], UkFormGroupComponent.prototype, "_items", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], UkFormGroupComponent.prototype, "valueChange", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], UkFormGroupComponent.prototype, "value", null);
    UkFormGroupComponent = __decorate([
        __param(0, Optional()),
        __metadata("design:paramtypes", [NgControl, String, ChangeDetectorRef])
    ], UkFormGroupComponent);
    return UkFormGroupComponent;
}(_UkGenericFormGroupMixin));

var UK_ALIGMENT;
(function (UK_ALIGMENT) {
    UK_ALIGMENT["Horizontal"] = "horizontal";
    UK_ALIGMENT["Vertical"] = "vertical";
})(UK_ALIGMENT || (UK_ALIGMENT = {}));

export { UIKitCommonModule, UK_ALIGMENT, UK_SSN_MASK_SECTIONS, UK_SSN_SEPERATOR, UkBaseFormControl, UkChildItemComponent, UkEmailPipe, UkFieldInvalidEmailError, UkFieldInvalidUserNameError, UkFieldMaxLengthError, UkFieldRequiredError, UkFormGroupComponent, UkGenericFormGroupComponent, UkGroupComponent, UkPhonePipe, UkSSNPipe, UkSelectionChange, _UkBaseFormControl, _UkBaseFormControlMixin, _UkGenericFormGroupMixin, UkButtonGroupDirective as ɵa, UkAutofocusDirective as ɵb, mixinTouchable as ɵc, mixinErrorState as ɵd, UkGenericComponent as ɵe };
//# sourceMappingURL=uikit-components-common.js.map
